import { render } from "./topComponent.vue?vue&type=template&id=13f868c7&scoped=true"
import script from "./topComponent.vue?vue&type=script&lang=js"
export * from "./topComponent.vue?vue&type=script&lang=js"

import "./topComponent.vue?vue&type=style&index=0&id=13f868c7&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-13f868c7"

export default script